import { render, staticRenderFns } from "./WorkUnitEdit.vue?vue&type=template&id=22286970&"
import script from "./WorkUnitEdit.vue?vue&type=script&lang=js&"
export * from "./WorkUnitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports